import { c as _c } from "react/compiler-runtime";
import { IconArchive } from "@tabler/icons-react";

/**
 * Icône d'un sous-élément de navigation. L'attribut `data-navigation-sub-item`
 * sert de repère aux classes `has-[…]` du lien : la librairie de navigation ne
 * connaît qu'un seul niveau et n'accepte pas de classe par élément, c'est donc
 * ce marqueur qui permet d'indenter l'entrée sous sa rubrique.
 */
export const NavigationSubItemIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span data-navigation-sub-item={true} className="flex items-center justify-center"><IconArchive size={16} /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};